import { Entity } from '@shapeable/types';
import { intersection, compact } from 'lodash';

export const linkedMatchesFilter = (linkedValues: Entity[], filterValues: string[]) => {
  // if no filter values, implicitly match
  if (!filterValues.length) return true;
  
  return intersection(filterValues, compact((linkedValues || []).map(e => e?.slug))).length > 0;
};